module.exports = __webpack_public_path__ + "img/10031.97f143c1.jpg";